module.exports = __webpack_public_path__ + "img/sweden-tuberculosis-female.5e24a7cd.png";